import React, { useState, useEffect } from "react";
import Loading from "../common/Loading";
import RightFooter from "../common/RightFooter";
import {Box, Typography} from "@mui/material";

const Interview = () => {

  return (
    <div className="lykioccs-main-content lykiocss-colloquio">
       <>
          <div className="lykiocss-margin-top-4em" style={{display:'flex', justifyContent: 'center'}}>
          <Box
              bgcolor="rgb(0, 61, 125)"
              color="white"
              borderRadius={8}
              p={3}
              m={2}
              textAlign={'center'}
              justifyContent="center"
              alignItems="center"
              style={{maxWidth:'50em'}}
          >


        <p style={{fontSize:'21px'}}>Benvenut* al colloquio con l'avatar! Qui potrei interagire con un digital human per allenare le tue capacità di valutazione e comunicazione!</p>
          </Box>
          </div>
        </>
      <RightFooter />
    </div>
  );
};

export default Interview;
